export default __webpack_public_path__ + "static/media/shopping-cart-add.28383ae3.svg";